import React from 'react';
import ConnectionView from './ConnectionView';
import PropTypes from 'prop-types';
import { SFEntityID, starfishMediaType, SFNotification } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage, noNil, joinURL } from 'utils/request';
import { withNotification } from 'common/withNotification';

class ConnectionContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      connection: null,
      hasFetched: false
    };
  }

  componentDidMount() {
    const { id, serviceId } = this.props;
    fetchAuthenticatedJSON(
      joinURL(`../api/starfish/success-network/connections/${id}`, noNil({ serviceId })), {
        method: 'GET',
        headers: {
          'Accept': starfishMediaType('successnetwork')
        }
      })
    .then(connection => this.setState({connection}))
    .catch(e => this.props.notification.error(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return (
      <ConnectionView
        {...this.state}
        serviceId={this.props.serviceId}
        isStudent={this.props.isStudent}
        isStaff={this.props.isStaff}
        renderNotification={this.props.notification.render}
      />
    );
  }
}

ConnectionContainer.propTypes = {
  id: SFEntityID.isRequired,
  isStudent: PropTypes.bool.isRequired,
  isStaff: PropTypes.bool.isRequired,
  notification: SFNotification.isRequired,
  serviceId: SFEntityID
};

export default withNotification(ConnectionContainer);
